// extracted by mini-css-extract-plugin
export default {"root":"styles_root__rdV9V","checkbox":"styles_checkbox__IAd9l","model":"styles_model__bADY-"};